(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/init.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
svs.tickets.init = () => {
  var _appTimeline$add, _svs$tickets$data;
  if (svs.core.detect.feature('ft-tickets-init-next')) {
    console.log('Initializing nextgen ticket lobby');
  }
  svs.tickets.logger = new svs.core.log.Logger('module:tickets');
  const _svs$app$ReactRouter = svs.app.ReactRouter,
    matchPath = _svs$app$ReactRouter.matchPath,
    PlayerRouter = _svs$app$ReactRouter.PlayerRouter;
  const _React = React,
    useEffect = _React.useEffect,
    useState = _React.useState;
  const _svs$tickets$play$uti = svs.tickets.play.utils.constants,
    PICK_PATH = _svs$tickets$play$uti.PICK_PATH,
    PLAY_PATH = _svs$tickets$play$uti.PLAY_PATH;
  const Route = svs.app.ReactRouter.Route;
  const Menu = svs.tickets.play.components.Menu;
  const baseUrl = svs.core.data.baseUrl;
  const PlayContainer = svs.tickets.play.containers.PlayContainer;
  const GameLauncherWrapper = svs.tickets.play.containers.GameLauncherWrapper;
  const availableTickets = svs.tickets.data.moduleConfig.availableTickets;
  const _svs$tickets$play$uti2 = svs.tickets.play.utils.utils,
    getTicketInfo = _svs$tickets$play$uti2.getTicketInfo,
    getMenuProduct = _svs$tickets$play$uti2.getMenuProduct;
  const Background = svs.tickets.play.components.Background;
  const _svs$tickets$play$uti3 = svs.tickets.play.utils.context,
    useTicketContext = _svs$tickets$play$uti3.useTicketContext,
    TicketProvider = _svs$tickets$play$uti3.TicketProvider;
  const HiddenRoute = svs.tickets.play.containers.HiddenRoute;
  const _svs$tickets$play$uti4 = svs.tickets.play.utils.TicketListener(),
    listener = _svs$tickets$play$uti4.listener,
    setPaused = _svs$tickets$play$uti4.setPaused;
  const appTimeline = new gsap.timeline();
  gsap.ticker.lagSmoothing(0);
  appTimeline.addLabel('showUsp', 0);
  appTimeline.addLabel('hideUsp', 2);
  appTimeline.addLabel('gameReady', 3);
  appTimeline.addLabel('introDone', 5);
  appTimeline === null || appTimeline === void 0 || (_appTimeline$add = appTimeline.add) === null || _appTimeline$add === void 0 || _appTimeline$add.call(appTimeline, () => {}, 'gameReady'); 

  const menuProducts = availableTickets.filter(p => p.open);
  const DispatcherRoute = _ref => {
    let children = _ref.children,
      isMatch = _ref.isMatch;
    const _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      dispatcherProps = _useState2[0],
      setDispatcherProps = _useState2[1];
    const _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      wasMatch = _useState4[0],
      setWasMatch = _useState4[1];
    useEffect(() => {
      if (isMatch === false && wasMatch === true) {
        setDispatcherProps(undefined);
      }
      setWasMatch(isMatch);
    }, [isMatch]);
    useEffect(() => {
      window.addEventListener('PRELOAD_TICKET', _ref2 => {
        let detail = _ref2.detail;
        setDispatcherProps(detail);
        setPaused(true);
      });
    }, []);
    return isMatch || dispatcherProps ? React.createElement(React.Fragment, null, React.Children.map(children, child => React.cloneElement(child, dispatcherProps))) : null;
  };
  const hasUnscratchedTicket = ((_svs$tickets$data = svs.tickets.data) === null || _svs$tickets$data === void 0 ? void 0 : _svs$tickets$data.fetchedGames) && svs.tickets.data.fetchedGames.length > 1;
  const router = React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, React.createElement(Background, null), React.createElement(Menu, {
    appTimeline: appTimeline,
    products: menuProducts
  }), React.createElement(Route, {
    component: _ref3 => {
      var _ticketInfo2;
      let match = _ref3.match,
        history = _ref3.history;
      const _useTicketContext = useTicketContext(),
        updateTicketInfo = _useTicketContext.updateTicketInfo;
      const routeMatch = matchPath(match.url, {
        path: PLAY_PATH,
        exact: true,
        strict: false
      });
      const ticketInfoMatch = matchPath(history.location.pathname, {
        path: [PICK_PATH, PLAY_PATH]
      });
      let wagerId;
      let skinId;
      let ticketInfo;
      let ticketNumber;
      let demo;
      if (routeMatch) {
        var _ticketInfo;
        wagerId = routeMatch.params.wagerId.toLowerCase();

        const sameAlternativeUrlTicketTypes = availableTickets.filter(ticket => {
          var _ticket$alternativeUr;
          return ((_ticket$alternativeUr = ticket.alternativeUrl) === null || _ticket$alternativeUr === void 0 ? void 0 : _ticket$alternativeUr.toLowerCase()) === routeMatch.params.ticketType;
        }).map(ticket => ticket.type.toLowerCase());
        const ticketTypes = sameAlternativeUrlTicketTypes.length > 0 ? sameAlternativeUrlTicketTypes : [routeMatch.params.ticketType.toLowerCase()];
        ticketInfo = availableTickets.find(ticket => ticketTypes.includes(ticket.type.toLowerCase()));
        ticketNumber = parseInt(svs.utils.paramHandler.get({
          key: 'ticketNumber'
        }).value, 10) || null;
        demo = wagerId === 'demo';
        skinId = (_ticketInfo = ticketInfo) !== null && _ticketInfo !== void 0 && _ticketInfo.defaultSkin ? 1 : svs.utils.paramHandler.get({
          key: 'skinId'
        }).value;
      }
      setPaused(false);
      const onClose = e => {
        var _appTimeline$pause, _appTimeline$seek;
        e === null || e === void 0 || e.preventDefault();
        appTimeline === null || appTimeline === void 0 || (_appTimeline$pause = appTimeline.pause) === null || _appTimeline$pause === void 0 || _appTimeline$pause.call(appTimeline);
        appTimeline === null || appTimeline === void 0 || (_appTimeline$seek = appTimeline.seek) === null || _appTimeline$seek === void 0 || _appTimeline$seek.call(appTimeline, 'gameReady');
        history.push("../../valja/".concat(ticketInfoMatch.params.ticketType));
      };
      const props = {
        appTimeline,
        demo,
        hasUnscratchedTicket,
        history,
        onClose,
        skinId,
        ticketInfo,
        ticketNumber,
        wagerId,
        listener
      };
      useEffect(() => {
        updateTicketInfo(ticketInfo);
      }, [(_ticketInfo2 = ticketInfo) === null || _ticketInfo2 === void 0 ? void 0 : _ticketInfo2.type]);
      return React.createElement(HiddenRoute, {
        displayPath: PLAY_PATH,
        url: match.url
      }, React.createElement(DispatcherRoute, {
        isMatch: Boolean(routeMatch)
      }, React.createElement(GameLauncherWrapper, props)));
    },
    path: "*"
  }), React.createElement(Route, {
    component: _ref4 => {
      let match = _ref4.match,
        history = _ref4.history;
      const _useTicketContext2 = useTicketContext(),
        updateTicketInfo = _useTicketContext2.updateTicketInfo;
      const _svs$tickets$play$uti5 = svs.tickets.play.utils.utils.getTicketTypeFromWager(match.params.wagerId),
        ticketType = _svs$tickets$play$uti5.ticketType,
        wagerId = _svs$tickets$play$uti5.wagerId,
        gameIsCompleted = _svs$tickets$play$uti5.gameIsCompleted;
      const onClose = e => {
        e === null || e === void 0 || e.preventDefault();
        window.location.href = svs.core.urlMapping.get('myBetsHome');
      };
      const ticketInfo = getTicketInfo(ticketType, svs.tickets.data.scratchTickets);
      const props = {
        appTimeline,
        gameIsCompleted,
        demo: false,
        hasUnscratchedTicket,
        history,
        onClose,
        ticketInfo,
        wager: svs.tickets.data.fetchedGame,
        wagerId
      };
      useEffect(() => {
        updateTicketInfo(ticketInfo);
      }, [ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type]);
      return React.createElement(GameLauncherWrapper, props);
    },
    exact: true,
    path: "/mina-spel/:wagerId"
  }), React.createElement(Route, {
    component: _ref5 => {
      let match = _ref5.match;
      const _useTicketContext3 = useTicketContext(),
        updateTicketInfo = _useTicketContext3.updateTicketInfo;
      const ticketType = match.params.ticketType;
      const ticketInfo = getMenuProduct(ticketType, menuProducts);
      if (ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.defaultSkin) {
        ticketInfo.variations = 1;
      }
      appTimeline.pause();
      if (!ticketInfo || !ticketInfo.type) {
        window.location.href = "../valja/".concat(menuProducts[0].type);
        return React.createElement("div", null);
      }
      useEffect(() => {
        var _svs$tickets$data$mod;
        updateTicketInfo(ticketInfo);
        const moduleTitle = (_svs$tickets$data$mod = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod === void 0 ? void 0 : _svs$tickets$data$mod.moduleTitle;
        const title = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.title) || moduleTitle;
        if (title) {
          document.title = title;
        }
      }, [ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type]);
      return React.createElement(PlayContainer, {
        appTimeline: appTimeline,
        history: history,
        setPaused: setPaused,
        ticketInfo: ticketInfo
      });
    },
    exact: true,
    path: "/valja/:ticketType"
  }));
  ReactDOM.render(React.createElement(TicketProvider, null, router), document.getElementById('reactContainer'));
};
svs.tickets.init();

 })(window);